import { render, staticRenderFns } from "./NotificationEventGroup.vue?vue&type=template&id=63f55271&scoped=true"
import script from "./NotificationEventGroup.vue?vue&type=script&lang=js"
export * from "./NotificationEventGroup.vue?vue&type=script&lang=js"
import style0 from "./NotificationEventGroup.vue?vue&type=style&index=0&id=63f55271&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f55271",
  null
  
)

export default component.exports